import type { Option } from '@zen/DesignSystem/types';

import { VolumeUnit } from './types';

export const volumeUnitOptions: Option<VolumeUnit>[] = [
  { label: 'cbm', value: VolumeUnit.CBM },
  { label: 'cft', value: VolumeUnit.CFT }
];
